@let nextFilter = nextFilter$ | async;

<app-compatibility-card id="brandSelection">
  <h3>{{ 'compatibility.brands.title' | translate }}</h3>
  <h4>{{ 'compatibility.brands.select' | translate }}</h4>

  <!-- PARTNER BLOCK HEADER -->
  <div id="partners-block">
    <div id="partner-badges">
      <img
        class="partner-badge"
        src="assets/images/partnership/badges/gold-badge.svg"
        alt="the kinomap gold partner badge"
       />
      <img
        class="partner-badge silver-badge"
        src="assets/images/partnership/badges/silver-badge.svg"
        alt="the kinomap silver partner badge"
       />
    </div>
    <div id="partners-block-content">
      <h3>{{ 'partnership.partnership' | translate | titlecase }}</h3>
      <p>{{ 'partnership.description' | translate }}</p>
    </div>
  </div>

  <div class="filters">
    @for (character of filters; track $index) {
      <div
        (click)="onFilterBrands(character)"
        class="filter"
        [ngClass]="{
          'filter-num': character === '0-9',
          'filter-partner': character === 'PARTNER',
          active: (selectedFilter$ | async) === character,
        }">
        @if ((selectedFilter$ | async) === character) {
          <div class="filter-selector"></div>
        }
        <span class="filter-label">
          {{ character | uppercase }}
        </span>
      </div>
    }
  </div>

  @if ((isLoadingBrands$ | async) !== true) {
    <ng-container>
      <!-- Section TITLE : 🥇 GOLD BRAND PARTNER  -->
      @if ((goldBrandPartner$ | async).length > 0) {
        <div class="selected-filter">
          {{
            (selectedFilter$ | async) !== 'PARTNER'
              ? (selectedFilter$ | async | uppercase) + ' -'
              : ''
          }}
          {{ 'partnership.gold-partners' | translate | uppercase }}
        </div>
      }
      @if ((goldBrandPartner$ | async).length > 0) {
        <div class="brands">
          @for (brand of goldBrandPartner$ | async; track $index) {
            <brand-item [brand]="brand"></brand-item>
          }
        </div>
      }

      <!-- Section TITLE : 🥈 SILVER BRAND PARTNER  -->
      @if ((silverBrandPartner$ | async).length > 0) {
        <div class="selected-filter">
          {{
            (selectedFilter$ | async) !== 'PARTNER'
              ? (selectedFilter$ | async | uppercase) + ' -'
              : ''
          }}
          {{ 'partnership.silver-partners' | translate | uppercase }}
        </div>
        <div class="brands">
          @for (brand of silverBrandPartner$ | async; track $index) {
            <brand-item [brand]="brand"></brand-item>
          }
        </div>
      }

      <!-- Section TITLE : 🥉 BRONZE BRAND PARTNER  -->
      <div class="selected-filter">
        {{
          (selectedFilter$ | async) !== 'PARTNER'
            ? (selectedFilter$ | async | uppercase) + ' -'
            : ''
        }}
        {{ 'partnership.other-partners' | translate | uppercase }}
      </div>
      <div class="brands">
        @for (brand of bronzeBrandPartner$ | async; track $index) {
          <brand-item [brand]="brand"></brand-item>
        }
      </div>

      @if (nextFilter) {
        <div class="following" (click)="onFilterBrands(nextFilter)">
          {{ 'compatibility.brands.seeAll' | translate }}
          {{ nextFilter$ | async | uppercase }}
        </div>
      }
    </ng-container>
  } @else {
    <ng-container>
      <div class="spinner">
        <app-loading
          [display]="isLoadingBrands$ | async"
          [width]="20"
          [height]="20"></app-loading>
        <div class="loading-label">
          {{ 'compatibility.brands.loading' | translate }}
        </div>
      </div>
    </ng-container>
  }
</app-compatibility-card>
